<template>
  <div class="app-container">
    <el-card shadow="never">
      <div slot="header"><span>捷旅 Worker 并发控制</span></div>
      <el-alert title="配置保存到共享数据库，所有 API 实例下一轮调度生效；订单 worker 上限为 16。" type="info" :closable="false" show-icon />
      <el-table v-loading="loading" :data="rows" border size="small" style="margin-top: 16px; max-width: 900px">
        <el-table-column prop="scope" label="范围" width="160" />
        <el-table-column label="并发数" width="220"><template slot-scope="scope"><el-input-number v-model="scope.row.worker_count" :min="1" :max="scope.row.scope === 'order' ? 16 : 512" size="small" /></template></el-table-column>
        <el-table-column prop="updated_at" label="更新时间" />
        <el-table-column label="操作" width="100"><template slot-scope="scope"><el-button type="primary" size="mini" @click="save(scope.row)">保存</el-button></template></el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  data() { return { loading: false, rows: [] } },
  created() { this.load() },
  methods: {
    load() { this.loading = true; return request({ url: '/api/backend/jielv/worker-controls', method: 'get' }).then(r => { this.rows = r.data.items || [] }).finally(() => { this.loading = false }) },
    save(row) { return request({ url: '/api/backend/jielv/worker-controls', method: 'post', data: { scope: row.scope, worker_count: row.worker_count } }).then(r => { this.$message.success(r.msg || '配置已保存'); this.load() }) },
  },
}
</script>
